import type { TranscriptBreakdown, TranscriptSystemKind } from '../types';

export const SYSTEM_TRANSCRIPT_LABELS: Record<TranscriptSystemKind, string> = {
  associate: 'Associate degree',
  bachelor: "Bachelor's degree",
  additional: 'Additional credits',
};

export const SYSTEM_TRANSCRIPT_NOTE =
  'Added automatically from your academic information. To change it, edit your info.';

export const isSystemTranscript = (transcript: TranscriptBreakdown): boolean =>
  transcript.systemKind != null;
